// business_budget_v1 M5+M6: หน้างบธุรกิจ
// แท็บ "จัดบรรทัด" (template editor) + "กรอกงบรายเดือน" (period + values + calc สด)
import React, { useState, useEffect } from 'react';
import API from '../api';

const BU = '/api/finance/budget';
const FB = '/api/finance/businesses';
const PA = '/api/finance/partners';

const inp = { width: '100%', padding: 9, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, marginTop: 4, marginBottom: 12, boxSizing: 'border-box' };
const lbl = { fontSize: 12, color: '#64748b', fontWeight: 600 };
const btnPrimary = { background: '#10b981', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', cursor: 'pointer', fontSize: 14, fontWeight: 600 };
const btnSec = { background: '#fff', color: '#475569', border: '1px solid #e2e8f0', borderRadius: 8, padding: '9px 18px', cursor: 'pointer', fontSize: 14, fontWeight: 600 };
const btnFinalize = { background: '#f59e0b', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', cursor: 'pointer', fontSize: 14, fontWeight: 600 }; /* business_budget_v1 M7a */
const card = { background: '#fff', borderRadius: 12, padding: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.05)' };
const money = function (n) { return Number(n || 0).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }); };

const TYPE_OPTIONS = [
  { value: 'manual', label: '✍️ กรอกเอง' },
  { value: 'finance', label: '🔗 ดึงจากการเงิน' },
  { value: 'percent', label: '% ของบรรทัดอื่น' },
  { value: 'sum', label: 'Σ รวมบรรทัด' },
  { value: 'partner', label: '🤝 ส่วนแบ่ง partner' }
];
const TYPE_LABEL = { manual: 'กรอกเอง', finance: 'ดึงการเงิน', percent: '% บรรทัด', sum: 'รวมบรรทัด', partner: 'partner' };

const emptyForm = function () {
  return { id: null, label: '', line_type: 'manual', display_sign: 1,
    base_line_id: '', rate: '', sign: 1, line_ids: [], partner_id: '',
    pmode: 'percent', /* budget_partner_manual_v1: โหมด partner (percent/manual) */
    fin_source: 'expense', fin_category: '', fin_account_id: '' };
};

// ============================================
// Main — business selector + tabs
// ============================================
export default function BillBudget() {
  const [businesses, setBusinesses] = useState([]);
  const [bizId, setBizId] = useState('');
  const [partners, setPartners] = useState([]);
  const [tab, setTab] = useState('period'); // period | template | summary

  useEffect(function () {
    API.get(FB).then(function (r) {
      setBusinesses(r.data || []);
      if (r.data && r.data.length) setBizId(function (cur) { return cur || r.data[0].id; });
    }).catch(function () {});
    API.get(PA).then(function (r) { setPartners(r.data || []); }).catch(function () {});
  }, []);

  const tabBtn = function (key, label) {
    var active = tab === key;
    return (
      <button onClick={function () { setTab(key); }} style={{
        background: active ? '#10b981' : '#f1f5f9', color: active ? '#fff' : '#475569',
        border: 'none', borderRadius: 8, padding: '8px 16px', cursor: 'pointer', fontSize: 14, fontWeight: 600, marginRight: 8
      }}>{label}</button>
    );
  };

  return (
    <div style={{ maxWidth: 1100, margin: '0 auto' }}>
      <div style={{ marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>📊 งบธุรกิจ</h2>
        <p style={{ margin: '4px 0 0', fontSize: 13, color: '#64748b' }}>งบกำไรขาดทุนรายเดือนต่อธุรกิจ — กรอกค่า คำนวณอัตโนมัติ + USDT</p>
      </div>

      {/* budget_summary_all_v1: ซ่อน business selector เมื่ออยู่แท็บสรุปรวม (ดูทุกธุรกิจ) */}
      {tab !== 'summary' && (
        <div style={Object.assign({}, card, { marginBottom: 16 })}>
          <span style={lbl}>ธุรกิจ</span>
          <select value={bizId} onChange={function (e) { setBizId(e.target.value); }} style={inp}>
            {businesses.map(function (b) { return <option key={b.id} value={b.id}>{b.name}</option>; })}
          </select>
        </div>
      )}

      <div style={{ marginBottom: 16 }}>
        {tabBtn('period', 'กรอกงบรายเดือน')}
        {tabBtn('template', 'จัดบรรทัด (โครง)')}
        {tabBtn('summary', '📊 สรุปรวมทุกธุรกิจ')}
      </div>

      {tab === 'period' && bizId && <PeriodTab bizId={bizId} />}
      {tab === 'template' && bizId && <TemplateTab bizId={bizId} partners={partners} businesses={businesses} />}
      {tab === 'summary' && <SummaryAllTab businesses={businesses} />}
    </div>
  );
}

// ============================================
// Template Tab — จัดโครงบรรทัด (M5)
// ============================================
function TemplateTab(props) {
  const bizId = props.bizId;
  const partners = props.partners || [];
  const businesses = props.businesses || []; /* budget_copy_lines_v1 */
  const [lines, setLines] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(null); // form object หรือ null
  const [err, setErr] = useState('');
  const [saved, setSaved] = useState(''); // ชื่อบรรทัดที่เพิ่งเพิ่ม (feedback)
  // budget_copy_lines_v1: คัดลอกโครงไปธุรกิจอื่น
  const [showCopy, setShowCopy] = useState(false);
  const [copyTo, setCopyTo] = useState('');
  const [copyMsg, setCopyMsg] = useState('');

  const loadLines = function () {
    if (!bizId) { setLines([]); return; }
    setLoading(true);
    API.get(BU + '/lines', { params: { business_id: bizId } })
      .then(function (r) { setLines(r.data || []); setLoading(false); })
      .catch(function () { setLines([]); setLoading(false); });
  };
  useEffect(loadLines, [bizId]);

  // ── form helpers ──
  const openNew = function () { setErr(''); setSaved(''); setEditing(emptyForm()); };
  const openEdit = function (l) {
    setErr(''); setSaved('');
    var c = l.config || {};
    setEditing({
      id: l.id, label: l.label, line_type: l.line_type, display_sign: l.display_sign || 1,
      base_line_id: c.base_line_id || '', rate: (c.rate !== undefined ? c.rate : ''),
      sign: (Number(c.sign) === -1 ? -1 : 1), line_ids: Array.isArray(c.line_ids) ? c.line_ids : [],
      partner_id: c.partner_id || '', fin_source: c.source || 'expense',
      pmode: (c.mode === 'manual' ? 'manual' : 'percent'), /* budget_partner_manual_v1 */
      fin_category: c.category || '', fin_account_id: c.account_id || ''
    });
  };
  const setF = function (k, v) { setEditing(function (prev) { var n = Object.assign({}, prev); n[k] = v; return n; }); };

  const buildConfig = function (f) {
    // budget_partner_manual_v1: partner โหมดกรอกยอดเอง — ไม่ผูกบรรทัดฐาน/rate
    if (f.line_type === 'partner' && f.pmode === 'manual') {
      return { mode: 'manual', partner_id: f.partner_id };
    }
    if (f.line_type === 'percent' || f.line_type === 'partner') {
      var cfg = { base_line_id: f.base_line_id, rate: Number(f.rate) || 0, sign: (Number(f.sign) === -1 ? -1 : 1) };
      if (f.line_type === 'partner') cfg.partner_id = f.partner_id;
      return cfg;
    }
    if (f.line_type === 'sum') return { line_ids: f.line_ids };
    if (f.line_type === 'finance') {
      var fc = { source: f.fin_source, sign: (Number(f.sign) === -1 ? -1 : 1) };
      if (f.fin_category) fc.category = f.fin_category;
      if (f.fin_account_id) fc.account_id = f.fin_account_id;
      return fc;
    }
    return {};
  };

  const validate = function (f) {
    if (!f.label || !f.label.trim()) return 'ต้องระบุชื่อบรรทัด';
    // budget_partner_manual_v1: partner โหมด manual เช็คแค่เลือก partner (ไม่ต้องมีฐาน/rate)
    if (f.line_type === 'partner' && f.pmode === 'manual') {
      if (!f.partner_id) return 'เลือกพาร์ทเนอร์';
      return '';
    }
    if (f.line_type === 'percent' || f.line_type === 'partner') {
      if (!f.base_line_id) return 'เลือกบรรทัดฐาน';
      if (!(Number(f.rate) > 0)) return 'ระบุ % (มากกว่า 0)';
      if (f.line_type === 'partner' && !f.partner_id) return 'เลือกพาร์ทเนอร์';
    }
    if (f.line_type === 'sum' && (!f.line_ids || !f.line_ids.length)) return 'เลือกบรรทัดที่จะรวมอย่างน้อย 1';
    return '';
  };

  const save = function () {
    var f = editing;
    var v = validate(f);
    if (v) { setErr(v); return; }
    var isNew = !f.id;
    var payload = { business_id: bizId, label: f.label.trim(), line_type: f.line_type,
      config: buildConfig(f), display_sign: f.display_sign };
    var req = isNew ? API.post(BU + '/lines', payload) : API.put(BU + '/lines/' + f.id, payload);
    req.then(function () {
      loadLines();
      if (isNew) {
        // เพิ่มใหม่: form ค้างไว้พร้อมกรอกอันถัดไป (คง type/sign เดิมไว้ ลด typing)
        setErr('');
        setSaved(f.label.trim());
        setEditing(Object.assign(emptyForm(), { line_type: f.line_type, display_sign: f.display_sign, pmode: f.pmode }));
      } else {
        setEditing(null); // แก้: ปิด form ตามเดิม
      }
    }).catch(function (e) { setErr((e.response && e.response.data && e.response.data.error) || 'บันทึกไม่สำเร็จ'); });
  };

  const del = function (l) {
    if (!window.confirm('ลบบรรทัด "' + l.label + '"? (บรรทัดอื่นที่อ้างถึงอาจคำนวณผิด)')) return;
    API.delete(BU + '/lines/' + l.id).then(loadLines).catch(function () {});
  };

  // เรียง: สลับ seq กับเพื่อนบ้าน
  const move = function (idx, dir) {
    var j = idx + dir;
    if (j < 0 || j >= lines.length) return;
    var a = lines[idx], b = lines[j];
    Promise.all([
      API.put(BU + '/lines/' + a.id, { seq: b.seq }),
      API.put(BU + '/lines/' + b.id, { seq: a.seq })
    ]).then(loadLines).catch(function () {});
  };

  // budget_copy_lines_v1: คัดลอกบรรทัดทั้งหมดไปธุรกิจปลายทาง
  const doCopy = function () {
    if (!copyTo) return;
    var toName = (businesses.find(function (b) { return b.id === copyTo; }) || {}).name || 'ธุรกิจปลายทาง';
    if (!window.confirm('คัดลอกโครงบรรทัดทั้งหมด (' + lines.length + ' บรรทัด) ไปยัง "' + toName + '" ?\n\n'
      + '• บรรทัด % / รวม / partner จะถูกปรับให้อ้างบรรทัดในธุรกิจปลายทางอัตโนมัติ\n'
      + '• บรรทัดที่ดึงการเงิน: บัญชีจะถูกล้าง ต้องเลือกใหม่ในธุรกิจปลายทาง')) return;
    setCopyMsg('');
    API.post(BU + '/lines/copy', { from_business_id: bizId, to_business_id: copyTo })
      .then(function (r) {
        setCopyMsg('คัดลอกแล้ว ' + ((r.data && r.data.copied) || 0) + ' บรรทัด ไปยัง "' + toName + '" — สลับไปธุรกิจนั้นเพื่อตรวจสอบได้เลย');
        setCopyTo('');
      })
      .catch(function (e) {
        setCopyMsg((e.response && e.response.data && e.response.data.error) || 'คัดลอกไม่สำเร็จ');
      });
  };

  const labelOf = function (id) { var l = lines.find(function (x) { return x.id === id; }); return l ? l.label : '?'; };
  const cfgSummary = function (l) {
    var c = l.config || {};
    if (l.line_type === 'percent') return c.rate + '% ของ "' + labelOf(c.base_line_id) + '"';
    if (l.line_type === 'partner') { var p = partners.find(function (x) { return x.id === c.partner_id; }); var pn = (p ? p.name : '?'); return c.mode === 'manual' ? ('กรอกยอดเอง → ' + pn) : (c.rate + '% ของ "' + labelOf(c.base_line_id) + '" → ' + pn); }
    if (l.line_type === 'sum') return 'รวม ' + (c.line_ids ? c.line_ids.length : 0) + ' บรรทัด';
    if (l.line_type === 'finance') return (c.source === 'income' ? 'รายรับ' : 'รายจ่าย') + (c.category ? ' · ' + c.category : '');
    return '—';
  };

  return (
    <div>
      <div style={Object.assign({}, card, { marginBottom: 16 })}>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button style={btnPrimary} onClick={openNew}>+ เพิ่มบรรทัด</button>
          {/* budget_copy_lines_v1: ปุ่มคัดลอกโครงไปธุรกิจอื่น */}
          {lines.length > 0 && <button style={btnSec} onClick={function () { setShowCopy(!showCopy); setCopyMsg(''); }}>📋 คัดลอกโครงไปธุรกิจอื่น</button>}
        </div>
        {showCopy && (
          <div style={{ marginTop: 12, padding: 12, background: '#f8fafc', borderRadius: 8 }}>
            <div style={{ fontSize: 13, color: '#64748b', marginBottom: 8 }}>คัดลอกบรรทัดทั้งหมด ({lines.length}) จากธุรกิจนี้ไปยัง:</div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
              <select value={copyTo} onChange={function (e) { setCopyTo(e.target.value); }} style={Object.assign({}, inp, { marginBottom: 0, width: 240 })}>
                <option value="">— เลือกธุรกิจปลายทาง —</option>
                {businesses.filter(function (b) { return b.id !== bizId; }).map(function (b) { return <option key={b.id} value={b.id}>{b.name}</option>; })}
              </select>
              <button style={btnPrimary} onClick={doCopy} disabled={!copyTo}>คัดลอก</button>
            </div>
            {copyMsg && <div style={{ marginTop: 8, fontSize: 13, color: (copyMsg.indexOf('ไม่') >= 0 || copyMsg.indexOf('มีบรรทัด') >= 0) ? '#ef4444' : '#10b981', fontWeight: 600 }}>{copyMsg}</div>}
          </div>
        )}
      </div>

      {editing && (
        <LineForm form={editing} setF={setF} lines={lines} partners={partners} err={err} saved={saved}
          onSave={save} onCancel={function () { setEditing(null); setSaved(''); }} />
      )}

      <div style={card}>
        {loading ? <p style={{ color: '#94a3b8' }}>กำลังโหลด...</p> : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <thead>
              <tr style={{ textAlign: 'left', color: '#64748b', fontSize: 12 }}>
                <th style={{ padding: 8, width: 50 }}>ลำดับ</th>
                <th style={{ padding: 8 }}>ชื่อบรรทัด</th>
                <th style={{ padding: 8, width: 110 }}>ชนิด</th>
                <th style={{ padding: 8 }}>รายละเอียด</th>
                <th style={{ padding: 8, width: 130 }}></th>
              </tr>
            </thead>
            <tbody>
              {lines.length === 0 && <tr><td colSpan={5} style={{ padding: 16, color: '#94a3b8', textAlign: 'center' }}>ยังไม่มีบรรทัด — กด "เพิ่มบรรทัด"</td></tr>}
              {lines.map(function (l, idx) {
                return (
                  <tr key={l.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                    <td style={{ padding: 8, color: '#94a3b8' }}>{l.seq}</td>
                    <td style={{ padding: 8, fontWeight: 600, color: '#0f172a' }}>{l.label}</td>
                    <td style={{ padding: 8 }}><span style={{ fontSize: 12, background: '#f1f5f9', color: '#475569', padding: '2px 8px', borderRadius: 6 }}>{TYPE_LABEL[l.line_type]}</span></td>
                    <td style={{ padding: 8, color: '#64748b', fontSize: 13 }}>{cfgSummary(l)}</td>
                    <td style={{ padding: 8, textAlign: 'right' }}>
                      <button onClick={function () { move(idx, -1); }} style={miniBtn} title="เลื่อนขึ้น">↑</button>
                      <button onClick={function () { move(idx, 1); }} style={miniBtn} title="เลื่อนลง">↓</button>
                      <button onClick={function () { openEdit(l); }} style={miniBtn}>แก้</button>
                      <button onClick={function () { del(l); }} style={Object.assign({}, miniBtn, { color: '#ef4444' })}>ลบ</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

const miniBtn = { background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 6, padding: '4px 8px', cursor: 'pointer', fontSize: 13, marginLeft: 4, fontWeight: 600 };

// ============================================
// Period Tab — กรอกงบรายเดือน + calc สด (M6)
// ============================================
function PeriodTab(props) {
  const bizId = props.bizId;
  const [periods, setPeriods] = useState([]);
  const [pid, setPid] = useState('');
  const [calc, setCalc] = useState(null);          // { period, lines:[{id,seq,label,line_type,value,usdt,display_sign}] }
  const [manualEdits, setManualEdits] = useState({}); // line_id -> string (ค่าที่กรอก)
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [showNew, setShowNew] = useState(false);
  const [newMonth, setNewMonth] = useState('');     // YYYY-MM
  const [newRate, setNewRate] = useState('32');

  const loadPeriods = function () {
    API.get(BU + '/periods', { params: { business_id: bizId } })
      .then(function (r) {
        setPeriods(r.data || []);
        if (r.data && r.data.length) setPid(function (cur) { return cur || r.data[0].id; });
        else { setPid(''); setCalc(null); }
      }).catch(function () { setPeriods([]); });
  };
  useEffect(function () { setPid(''); setCalc(null); loadPeriods(); }, [bizId]);

  const loadCalc = function () {
    if (!pid) { setCalc(null); return; }
    setLoading(true);
    API.get(BU + '/periods/' + pid + '/calc')
      .then(function (r) {
        setCalc(r.data);
        // init manual inputs จากค่าปัจจุบัน
        var m = {};
        (r.data.lines || []).forEach(function (l) {
          if (l.line_type === 'manual' || (l.line_type === 'partner' && l.config && l.config.mode === 'manual')) m[l.id] = (l.manual_value === null || l.manual_value === undefined) ? '' : String(l.manual_value);
        });
        setManualEdits(m);
        setLoading(false);
      }).catch(function (e) {
        setLoading(false);
        setMsg((e.response && e.response.data && e.response.data.error) || 'โหลดงบไม่สำเร็จ');
        setCalc(null);
      });
  };
  useEffect(loadCalc, [pid]);

  const createPeriod = function () {
    if (!/^\d{4}-\d{2}$/.test(newMonth)) { setMsg('ระบุเดือนรูปแบบ YYYY-MM'); return; }
    API.post(BU + '/periods', { business_id: bizId, period: newMonth, usd_rate: Number(newRate) || 0 })
      .then(function (r) { setShowNew(false); setNewMonth(''); setMsg(''); loadPeriods(); setPid(r.data.id); })
      .catch(function (e) { setMsg((e.response && e.response.data && e.response.data.error) || 'สร้างงบไม่สำเร็จ'); });
  };

  const saveAndCalc = function () {
    if (!pid) return;
    var values = {};
    Object.keys(manualEdits).forEach(function (lid) {
      var v = manualEdits[lid];
      values[lid] = (v === '' || v === null) ? 0 : Number(v);
    });
    setLoading(true);
    API.put(BU + '/periods/' + pid + '/values', { values: values })
      .then(function () { setMsg('บันทึก + คำนวณแล้ว'); loadCalc(); })
      .catch(function (e) { setLoading(false); setMsg((e.response && e.response.data && e.response.data.error) || 'บันทึกไม่สำเร็จ'); });
  };

  const updateRate = function (rate) {
    if (!pid) return;
    API.put(BU + '/periods/' + pid, { usd_rate: Number(rate) || 0 })
      .then(function () { loadCalc(); })
      .catch(function () {});
  };

  // business_budget_v1 M7a: ปิดงบ (finalize) — lock งบ + sync คอม partner เป็นค้างจ่ายจริง
  const doFinalize = function () {
    if (!pid || !calc) return;
    if (!window.confirm('ปิดงบเดือน ' + calc.period.period + ' ?\n\n'
      + '• งบจะถูกล็อก แก้ไม่ได้จนกว่าจะกด "เปิดงบกลับมาแก้"\n'
      + '• บรรทัด partner จะถูกบันทึกเป็น "คอมค้างจ่าย" ให้พาร์ทเนอร์ทันที')) return;
    setLoading(true);
    API.post(BU + '/periods/' + pid + '/finalize')
      .then(function (r) {
        setMsg('ปิดงบแล้ว — สร้างคอม partner ' + ((r.data && r.data.commissions_synced) || 0) + ' รายการ');
        loadPeriods(); loadCalc();
      })
      .catch(function (e) {
        setLoading(false);
        setMsg((e.response && e.response.data && e.response.data.error) || 'ปิดงบไม่สำเร็จ');
      });
  };

  // business_budget_v1 M7a: เปิดงบกลับมาแก้ (unfinalize) — ลบคอมที่งบนี้สร้าง + ปลดล็อก
  const doUnfinalize = function () {
    if (!pid || !calc) return;
    if (!window.confirm('เปิดงบเดือน ' + calc.period.period + ' กลับมาแก้ไข ?\n\n'
      + '• คอมค้างจ่ายที่งบนี้สร้างให้ partner จะถูกลบออก\n'
      + '• แก้งบเสร็จต้องกด "ปิดงบ" ใหม่เพื่อสร้างคอมอีกครั้ง')) return;
    setLoading(true);
    API.post(BU + '/periods/' + pid + '/unfinalize')
      .then(function (r) {
        setMsg('เปิดงบกลับมาแก้ได้แล้ว — ลบคอม ' + ((r.data && r.data.commissions_removed) || 0) + ' รายการ');
        loadPeriods(); loadCalc();
      })
      .catch(function (e) {
        setLoading(false);
        setMsg((e.response && e.response.data && e.response.data.error) || 'เปิดงบไม่สำเร็จ');
      });
  };

  const isFinalized = calc && calc.period && calc.period.status === 'finalized';
  const valColor = function (v) { return Number(v) < 0 ? '#ef4444' : '#0f172a'; };

  return (
    <div>
      <div style={Object.assign({}, card, { marginBottom: 16 })}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'flex-end', flexWrap: 'wrap' }}>
          <div style={{ flex: 1, minWidth: 180 }}>
            <span style={lbl}>งบเดือน</span>
            <select value={pid} onChange={function (e) { setPid(e.target.value); }} style={Object.assign({}, inp, { marginBottom: 0 })}>
              {periods.length === 0 && <option value="">— ยังไม่มีงบ —</option>}
              {periods.map(function (p) { return <option key={p.id} value={p.id}>{p.period}{p.status === 'finalized' ? ' (ปิดแล้ว)' : ''}</option>; })}
            </select>
          </div>
          <button style={btnSec} onClick={function () { setShowNew(!showNew); setMsg(''); }}>+ งบเดือนใหม่</button>
        </div>

        {showNew && (
          <div style={{ marginTop: 12, padding: 12, background: '#f8fafc', borderRadius: 8 }}>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end' }}>
              <div><span style={lbl}>เดือน (YYYY-MM)</span><input value={newMonth} onChange={function (e) { setNewMonth(e.target.value); }} placeholder="2026-04" style={Object.assign({}, inp, { marginBottom: 0, width: 140 })} /></div>
              <div><span style={lbl}>เรท USD (1$=)</span><input type="number" value={newRate} onChange={function (e) { setNewRate(e.target.value); }} style={Object.assign({}, inp, { marginBottom: 0, width: 100 })} /></div>
              <button style={btnPrimary} onClick={createPeriod}>สร้าง</button>
            </div>
          </div>
        )}
      </div>

      {msg && <div style={{ marginBottom: 12, fontSize: 13, color: msg.indexOf('ไม่') >= 0 ? '#ef4444' : '#10b981', fontWeight: 600 }}>{msg}</div>}

      {!pid && <div style={card}><p style={{ color: '#94a3b8', textAlign: 'center', margin: 0 }}>ยังไม่มีงบเดือน — กด "+ งบเดือนใหม่"</p></div>}

      {pid && calc && (
        <div style={card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
            <div>
              <span style={{ fontSize: 18, fontWeight: 700 }}>งบเดือน {calc.period.period}</span>
              {isFinalized && <span style={{ marginLeft: 10, fontSize: 12, background: '#fef3c7', color: '#92400e', padding: '3px 10px', borderRadius: 6, fontWeight: 600 }}>ปิดงบแล้ว (แก้ไม่ได้)</span>}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 8 }}>
              <div style={{ fontSize: 13, color: '#64748b' }}>
                เรท USD: <input type="number" defaultValue={calc.period.usd_rate} disabled={isFinalized}
                  onBlur={function (e) { if (!isFinalized && Number(e.target.value) !== calc.period.usd_rate) updateRate(e.target.value); }}
                  style={{ width: 70, padding: 4, borderRadius: 6, border: '1px solid #e2e8f0', marginLeft: 4 }} />
              </div>
              {/* business_budget_v1 M7a: ปุ่มปิด/เปิดงบ */}
              {!isFinalized
                ? <button style={btnFinalize} onClick={doFinalize} disabled={loading || (calc.lines || []).length === 0}>🔒 ปิดงบ (สร้างคอม partner)</button>
                : <button style={btnSec} onClick={doUnfinalize} disabled={loading}>🔓 เปิดงบกลับมาแก้</button>}
            </div>
          </div>

          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <thead>
              <tr style={{ textAlign: 'left', color: '#64748b', fontSize: 12 }}>
                <th style={{ padding: 8, width: 40 }}>#</th>
                <th style={{ padding: 8 }}>รายการ</th>
                <th style={{ padding: 8, width: 160, textAlign: 'right' }}>จำนวนเงิน</th>
                <th style={{ padding: 8, width: 140, textAlign: 'right' }}>สุทธิ (บาท)</th>
                <th style={{ padding: 8, width: 110, textAlign: 'right' }}>USDT</th>
              </tr>
            </thead>
            <tbody>
              {(calc.lines || []).map(function (l) {
                var isManual = l.line_type === 'manual';
                // budget_partner_manual_v1: partner โหมด manual ก็แก้ได้ (กรอกยอดเอง) เหมือน manual
                var isEditable = isManual || (l.line_type === 'partner' && l.config && l.config.mode === 'manual');
                // budget_net_col_v1: ยอดสุทธิหลังคิดทิศ (บาท) — บรรทัดที่แก้ได้คำนวณสดจาก input × display_sign
                var netBaht;
                if (isEditable && !isFinalized) {
                  var rawV = manualEdits[l.id];
                  netBaht = (rawV === '' || rawV === undefined || rawV === null ? 0 : Number(rawV)) * (Number(l.display_sign) || 1);
                } else {
                  netBaht = Number(l.value) || 0;
                }
                return (
                  <tr key={l.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                    <td style={{ padding: 8, color: '#94a3b8' }}>{l.seq}</td>
                    <td style={{ padding: 8, fontWeight: l.line_type === 'sum' ? 700 : 500, color: '#0f172a' }}>
                      {l.label}
                      {!isManual && <span style={{ fontSize: 11, color: '#cbd5e1', marginLeft: 6 }}>{TYPE_LABEL[l.line_type]}</span>}
                    </td>
                    <td style={{ padding: 8, textAlign: 'right' }}>
                      {isEditable && !isFinalized ? (
                        <input type="number" value={manualEdits[l.id] === undefined ? '' : manualEdits[l.id]}
                          onChange={function (e) { var v = e.target.value; setManualEdits(function (prev) { var n = Object.assign({}, prev); n[l.id] = v; return n; }); }}
                          style={{ width: 140, padding: 6, borderRadius: 6, border: '1px solid #e2e8f0', textAlign: 'right' }} />
                      ) : (
                        <span style={{ fontWeight: l.line_type === 'sum' ? 700 : 500, color: valColor(l.value) }}>{money(l.value)}</span>
                      )}
                    </td>
                    {/* budget_net_col_v1: คอลัมน์ยอดสุทธิ (บาท) — เห็นบวก/ลบชัดเจน */}
                    <td style={{ padding: 8, textAlign: 'right' }}>
                      <span style={{ fontWeight: l.line_type === 'sum' ? 700 : 500, color: valColor(netBaht) }}>{netBaht > 0 ? '+' : ''}{money(netBaht)}</span>
                    </td>
                    <td style={{ padding: 8, textAlign: 'right', color: '#64748b' }}>{l.usdt === null ? '-' : money(l.usdt)}</td>
                  </tr>
                );
              })}
              {(calc.lines || []).length === 0 && <tr><td colSpan={5} style={{ padding: 16, color: '#94a3b8', textAlign: 'center' }}>ยังไม่มีบรรทัด — ไปแท็บ "จัดบรรทัด" ก่อน</td></tr>}
            </tbody>
          </table>

          {!isFinalized && (calc.lines || []).length > 0 && (
            <div style={{ marginTop: 16 }}>
              <button style={btnPrimary} onClick={saveAndCalc} disabled={loading}>{loading ? 'กำลังคำนวณ...' : 'บันทึก + คำนวณ'}</button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ============================================
// Line Form (เพิ่ม/แก้บรรทัด)
// ============================================
function LineForm(props) {
  var f = props.form, setF = props.setF, lines = props.lines, partners = props.partners;
  // budget_partner_manual_v1: partner โหมด manual = กรอกยอดเอง (ไม่ใช่ % ของบรรทัดอื่น)
  var isPartnerManual = f.line_type === 'partner' && f.pmode === 'manual';
  var isPct = f.line_type === 'percent' || (f.line_type === 'partner' && !isPartnerManual);
  // บรรทัดที่เลือกเป็นฐานได้ = บรรทัดอื่น (ไม่ใช่ตัวเอง)
  var baseOptions = lines.filter(function (l) { return l.id !== f.id; });

  var toggleSum = function (id) {
    var arr = f.line_ids.slice();
    var i = arr.indexOf(id);
    if (i >= 0) arr.splice(i, 1); else arr.push(id);
    setF('line_ids', arr);
  };

  return (
    <div style={Object.assign({}, card, { marginBottom: 16, border: '2px solid #10b981' })}>
      <h3 style={{ margin: '0 0 12px' }}>{f.id ? 'แก้บรรทัด' : 'เพิ่มบรรทัด'}</h3>

      <span style={lbl}>ชื่อบรรทัด</span>
      <input value={f.label} onChange={function (e) { setF('label', e.target.value); }} style={inp} placeholder="เช่น รวมยอดสมาชิก" />

      <span style={lbl}>ชนิดบรรทัด</span>
      <select value={f.line_type} onChange={function (e) { setF('line_type', e.target.value); }} style={inp}>
        {TYPE_OPTIONS.map(function (o) { return <option key={o.value} value={o.value}>{o.label}</option>; })}
      </select>

      {/* budget_partner_manual_v1: โหมดคำนวณ partner */}
      {f.line_type === 'partner' && (
        <div>
          <span style={lbl}>โหมดคำนวณ partner</span>
          <select value={f.pmode} onChange={function (e) {
            var m = e.target.value; setF('pmode', m);
            if (m === 'manual' && Number(f.display_sign) !== -1) setF('display_sign', -1); // default หักออก
          }} style={inp}>
            <option value="percent">% ของบรรทัดอื่น</option>
            <option value="manual">กรอกยอดเอง (เป็นเงิน)</option>
          </select>
        </div>
      )}

      {isPct && (
        <div>
          <span style={lbl}>คิด % ของบรรทัด (ฐาน)</span>
          <select value={f.base_line_id} onChange={function (e) { setF('base_line_id', e.target.value); }} style={inp}>
            <option value="">— เลือกบรรทัดฐาน —</option>
            {baseOptions.map(function (l) { return <option key={l.id} value={l.id}>{l.label}</option>; })}
          </select>
          <span style={lbl}>เปอร์เซ็นต์ (%)</span>
          <input type="number" value={f.rate} onChange={function (e) { setF('rate', e.target.value); }} style={inp} placeholder="เช่น 3" />
          <span style={lbl}>ทิศทาง</span>
          <select value={f.sign} onChange={function (e) { setF('sign', Number(e.target.value)); }} style={inp}>
            <option value={1}>+ (บวกเข้า)</option>
            <option value={-1}>− (หักออก)</option>
          </select>
        </div>
      )}

      {/* budget_partner_manual_v1: เลือก partner — แสดงทั้ง 2 โหมด */}
      {f.line_type === 'partner' && (
        <div>
          <span style={lbl}>พาร์ทเนอร์ (รับคอมจากบรรทัดนี้)</span>
          <select value={f.partner_id} onChange={function (e) { setF('partner_id', e.target.value); }} style={inp}>
            <option value="">— เลือกพาร์ทเนอร์ —</option>
            {partners.map(function (p) { return <option key={p.id} value={p.id}>{p.name}</option>; })}
          </select>
          {isPartnerManual && <div style={{ fontSize: 12, color: '#64748b', marginTop: -6, marginBottom: 12 }}>กรอกยอดเป็นเงินในแต่ละเดือน (หน้า "กรอกงบรายเดือน") — ค่าบวก ทิศหักออก = ธุรกิจจ่าย partner รับ</div>}
        </div>
      )}

      {f.line_type === 'sum' && (
        <div>
          <span style={lbl}>เลือกบรรทัดที่จะรวม</span>
          <div style={{ border: '1px solid #e2e8f0', borderRadius: 8, padding: 8, marginTop: 4, marginBottom: 12, maxHeight: 200, overflowY: 'auto' }}>
            {baseOptions.length === 0 && <div style={{ color: '#94a3b8', fontSize: 13 }}>ยังไม่มีบรรทัดอื่นให้รวม</div>}
            {baseOptions.map(function (l) {
              var checked = f.line_ids.indexOf(l.id) >= 0;
              return (
                <label key={l.id} style={{ display: 'block', padding: '4px 2px', cursor: 'pointer', fontSize: 14 }}>
                  <input type="checkbox" checked={checked} onChange={function () { toggleSum(l.id); }} style={{ marginRight: 8 }} />
                  {l.label}
                </label>
              );
            })}
          </div>
        </div>
      )}

      {f.line_type === 'finance' && (
        <div>
          <span style={lbl}>ดึงจาก</span>
          <select value={f.fin_source} onChange={function (e) { setF('fin_source', e.target.value); }} style={inp}>
            <option value="expense">รายจ่าย</option>
            <option value="income">รายรับ</option>
          </select>
          <span style={lbl}>หมวด (ว่าง = ทุกหมวด)</span>
          <input value={f.fin_category} onChange={function (e) { setF('fin_category', e.target.value); }} style={inp} placeholder="เช่น ค่าเช่า" />
          <span style={lbl}>ทิศทาง</span>
          <select value={f.sign} onChange={function (e) { setF('sign', Number(e.target.value)); }} style={inp}>
            <option value={1}>+ (บวกเข้า)</option>
            <option value={-1}>− (หักออก)</option>
          </select>
        </div>
      )}

      {(f.line_type === 'manual' || f.line_type === 'finance' || isPartnerManual) && (
        <div>
          <span style={lbl}>ทิศทางของค่า (กรอกบวก แล้วเลือกที่นี่)</span>
          <select value={f.display_sign} onChange={function (e) { setF('display_sign', Number(e.target.value)); }} style={inp}>
            <option value={1}>+ บวก (รายรับ/ยอดเข้า)</option>
            <option value={-1}>− ลบ (รายจ่าย/หักออก)</option>
          </select>
        </div>
      )}

      {props.saved && !props.err && <div style={{ color: '#10b981', fontSize: 13, marginBottom: 12, fontWeight: 600 }}>✓ เพิ่ม "{props.saved}" แล้ว — กรอกบรรทัดถัดไปได้เลย</div>}
      {props.err && <div style={{ color: '#ef4444', fontSize: 13, marginBottom: 12 }}>{props.err}</div>}
      <div>
        <button style={btnPrimary} onClick={props.onSave}>{f.id ? 'บันทึก' : 'บันทึก + เพิ่มต่อ'}</button>
        <button style={Object.assign({}, btnSec, { marginLeft: 8 })} onClick={props.onCancel}>{f.id ? 'ยกเลิก' : 'เสร็จ / ปิด'}</button>
      </div>
    </div>
  );
}

// ============================================
// Summary All Tab — สรุปงบทุกธุรกิจในหน้าเดียว (budget_summary_all_v1)
// เลือกเดือน → วนทุกธุรกิจ ดึงงบเดือนนั้น render ตารางเต็ม (read-only)
// ============================================
function SummaryAllTab(props) {
  const businesses = props.businesses || [];
  const [months, setMonths] = useState([]);            // เดือนทั้งหมดที่มีงบ (union ทุกธุรกิจ)
  const [month, setMonth] = useState('');
  const [periodsByBiz, setPeriodsByBiz] = useState({}); // bizId -> [{id, period, status}]
  const [data, setData] = useState([]);                 // [{ business, calc|null }]
  const [loading, setLoading] = useState(false);

  const valColor = function (v) { return Number(v) < 0 ? '#ef4444' : '#0f172a'; };

  // ดึง periods ทุกธุรกิจ → union เดือน + default เดือนล่าสุด
  useEffect(function () {
    if (!businesses.length) return;
    Promise.all(businesses.map(function (b) {
      return API.get(BU + '/periods', { params: { business_id: b.id } })
        .then(function (r) { return { bizId: b.id, periods: r.data || [] }; })
        .catch(function () { return { bizId: b.id, periods: [] }; });
    })).then(function (results) {
      var pmap = {}; var mset = {};
      results.forEach(function (x) {
        pmap[x.bizId] = x.periods;
        x.periods.forEach(function (p) { mset[p.period] = true; });
      });
      var mlist = Object.keys(mset).sort().reverse(); // ล่าสุดก่อน
      setPeriodsByBiz(pmap);
      setMonths(mlist);
      if (mlist.length) setMonth(function (cur) { return cur || mlist[0]; });
    });
  }, [businesses]);

  // เลือกเดือน → ดึง calc ของทุกธุรกิจที่มีงบเดือนนั้น
  useEffect(function () {
    if (!month) { setData([]); return; }
    setLoading(true);
    Promise.all(businesses.map(function (b) {
      var periods = periodsByBiz[b.id] || [];
      var pd = periods.find(function (p) { return p.period === month; });
      if (!pd) return Promise.resolve({ business: b, calc: null });
      return API.get(BU + '/periods/' + pd.id + '/calc')
        .then(function (r) { return { business: b, calc: r.data }; })
        .catch(function () { return { business: b, calc: null }; });
    })).then(function (results) { setData(results); setLoading(false); });
  }, [month, periodsByBiz]);

  return (
    <div>
      <div style={Object.assign({}, card, { marginBottom: 16 })}>
        <span style={lbl}>เดือน</span>
        <select value={month} onChange={function (e) { setMonth(e.target.value); }} style={Object.assign({}, inp, { marginBottom: 0 })}>
          {months.length === 0 && <option value="">— ยังไม่มีงบ —</option>}
          {months.map(function (m) { return <option key={m} value={m}>{m}</option>; })}
        </select>
      </div>

      {loading && <div style={card}><p style={{ color: '#94a3b8', textAlign: 'center', margin: 0 }}>กำลังโหลด...</p></div>}

      {!loading && data.map(function (d) {
        var isFin = d.calc && d.calc.period && d.calc.period.status === 'finalized';
        return (
          <div key={d.business.id} style={Object.assign({}, card, { marginBottom: 16 })}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
              <span style={{ fontSize: 17, fontWeight: 700, color: '#0f172a' }}>{d.business.name}</span>
              {isFin && <span style={{ fontSize: 12, background: '#fef3c7', color: '#92400e', padding: '3px 10px', borderRadius: 6, fontWeight: 600 }}>ปิดงบแล้ว</span>}
            </div>
            {!d.calc ? (
              <p style={{ color: '#94a3b8', margin: 0, fontSize: 14 }}>ไม่มีงบเดือน {month}</p>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
                <thead>
                  <tr style={{ textAlign: 'left', color: '#64748b', fontSize: 12 }}>
                    <th style={{ padding: 8, width: 40 }}>#</th>
                    <th style={{ padding: 8 }}>รายการ</th>
                    <th style={{ padding: 8, width: 160, textAlign: 'right' }}>จำนวนเงิน</th>
                    <th style={{ padding: 8, width: 120, textAlign: 'right' }}>USDT</th>
                  </tr>
                </thead>
                <tbody>
                  {(d.calc.lines || []).map(function (l) {
                    return (
                      <tr key={l.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                        <td style={{ padding: 8, color: '#94a3b8' }}>{l.seq}</td>
                        <td style={{ padding: 8, fontWeight: l.line_type === 'sum' ? 700 : 500, color: '#0f172a' }}>
                          {l.label}
                          {l.line_type !== 'manual' && <span style={{ fontSize: 11, color: '#cbd5e1', marginLeft: 6 }}>{TYPE_LABEL[l.line_type]}</span>}
                        </td>
                        <td style={{ padding: 8, textAlign: 'right' }}>
                          <span style={{ fontWeight: l.line_type === 'sum' ? 700 : 500, color: valColor(l.value) }}>{Number(l.value) > 0 ? '+' : ''}{money(l.value)}</span>
                        </td>
                        <td style={{ padding: 8, textAlign: 'right', color: '#64748b' }}>{l.usdt === null ? '-' : money(l.usdt)}</td>
                      </tr>
                    );
                  })}
                  {(d.calc.lines || []).length === 0 && <tr><td colSpan={4} style={{ padding: 16, color: '#94a3b8', textAlign: 'center' }}>ไม่มีบรรทัด</td></tr>}
                </tbody>
              </table>
            )}
          </div>
        );
      })}

      {!loading && months.length === 0 && <div style={card}><p style={{ color: '#94a3b8', textAlign: 'center', margin: 0 }}>ยังไม่มีงบในธุรกิจใดเลย — ไปสร้างงบที่แท็บ "กรอกงบรายเดือน" ก่อน</p></div>}
    </div>
  );
}
